import { __spreadArrays } from "tslib";
import { createElement as reactCreateElement } from 'react';
import scopedAttributeKey from '../common/attribute';
export var isScopedAttributeDisabled = shouldDisableScopedAttribute();
export function h(type, props) {
    var children = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        children[_i - 2] = arguments[_i];
    }
    var mergedProps = props;
    if ((props === null || props === void 0 ? void 0 : props.className) && typeof type === 'string' && !isScopedAttributeDisabled) {
        mergedProps[scopedAttributeKey] = props.className;
    }
    return reactCreateElement.apply(void 0, __spreadArrays([type, mergedProps], children));
}
function shouldDisableScopedAttribute() {
    var windowDisable;
    if (typeof window === 'object') {
        windowDisable = window.__dui_disable_scoped_attribute__;
    }
    var globalDisable;
    if (typeof global === 'object') {
        globalDisable = global.__dui_disable_scoped_attribute__;
    }
    return Boolean(windowDisable || globalDisable);
}
